const formatDateTimeValue = (dateValue) => {
	if (!dateValue) return '-';
	try {
		const date = new Date(dateValue);
		if (isNaN(date.getTime())) return dateValue;
		return date.toLocaleString('es-CL', { 
			day: '2-digit', 
			month: '2-digit', 
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
			hour12: false
		});
	} catch {
		return dateValue;
	}
};

export const adaptPaymentInfo = (preorderData) => {
	if (!preorderData) return [];
	console.log('Adapting payment info with data:', preorderData);

	const formatPrice = (price) => {
		return new Intl.NumberFormat('es-CL', {
			style: 'currency',
			currency: 'CLP',
			minimumFractionDigits: 0,
		}).format(price || 0);
	};

	const payment = preorderData?.purchase_detail
	const delivery = payment?.total_delivery
	const total = payment?.total
	const discount = payment?.total_discount
	const subTotal = payment?.sub_total + discount

	console.log('Payment details - Subtotal:', subTotal, 'Delivery:', delivery, 'Total:', total);
	const paymentTrackingId = preorderData?.payment_tracking?.[0]?.payment_tracking_id;

	return [{
		key: 'payment-1',
		payment_date: formatDateTimeValue(preorderData?.payment_tracking?.[0]?.created_at),
		products_total: formatPrice(subTotal || 0),
		shipping_total: formatPrice(delivery || 0),
		general_total: formatPrice(total || 0),
		payment_method: '-',
		payment_tracking_id: paymentTrackingId,
	}];
};
